"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const NotificationArea_1 = __importDefault(require("./NotificationArea"));
/**
 * Toolbar widget displaying the contributions in parameter. This class is not
 * to be extended. @see Contribution for how to provide toolbar widgets.
 * @param param0
 * @returns
 */
const Toolbar = (_a) => {
    var { contributions } = _a, props = __rest(_a, ["contributions"]);
    const contributionElements = react_1.default.useMemo(() => contributions
        .filter((contrib) => contrib.section === undefined || contrib.section === props.activeSection)
        .map((contrib) => contrib.create(Object.assign(Object.assign({}, props), { key: `toolbarEl${contrib.id}` }))), [props.activeSection]);
    return (react_1.default.createElement("nav", { id: "tr__top-menu" },
        react_1.default.createElement("div", { className: "tr__top-menu-buttons" }, contributionElements),
        react_1.default.createElement(NotificationArea_1.default, null)));
};
exports.default = Toolbar;
//# sourceMappingURL=Toolbar.js.map